<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M23.52,0a1.59,1.59,0,0,1,1.13.47,1.61,1.61,0,0,1,.47,1.13,1.56,1.56,0,0,1-.46,1.13L11.4,16,24.66,29.25a1.73,1.73,0,0,1,.36.52,1.59,1.59,0,0,1,.12.62A1.67,1.67,0,0,1,25,31a1.63,1.63,0,0,1-.87.87,1.67,1.67,0,0,1-.62.12,1.5,1.5,0,0,1-.62-.13,1.64,1.64,0,0,1-.52-.35L6.86,16,22.39.46A1.6,1.6,0,0,1,23.52,0Z"
        />
</svg>